import { AffiliateConstants, AffiliateSettingsConstants } from "@@types/IAffiliate";
import { OfferConstants } from "@@types/IOffer";
import { api } from "@services/apiClient";
import { AxiosPromise } from "axios";

export interface AffiliateDetailsResponseDataType {
  product: {
    name: string;
    salesCount: number;
    maxPrice: number;
    photo: string;
    format: string;
    description: string;
    producerName: string;
    producerEmail: string;
    productPage: string;
  };
  affiliatesEnabled: boolean;
  offers: {
    name: string;
    price: number;
    commission: number;
    chargeFrequency?: OfferConstants.ChargeFrequency;
    promotionalPrice?: number;
    isFree: boolean;
  }[];
  productAffiliateSettings: {
    userProducerName: string;
    supportPage: string;
    extendedCommissionEnabled: boolean;
    productLanguage: string;
    automaticAffiliateEnabled: boolean;
    oneTimeCommission: number;
    recurrenceCommission: number;
    recurrenceChargeTypes: AffiliateSettingsConstants.RecurrenceChargeTypes;
    commissionPreference: AffiliateSettingsConstants.CommissionPreference;
    recurrenceFixedCharges?: number;
    productDescription: string;
    supportRules: string;
    userProducerPhone: string;
    userProducerEmail: string;
  } | null;
}

export interface AffiliateProductResponseDataType {
  productUuid: string;
  productName: string;
  salesCount: number;
  salesIncome: number;
  productPhoto: string;
  productFormatName: string;
  visitedInLastThirtyDays: number;
  conversionRate: number;
}

export async function fetchAffiliateDetails(uuid: string): Promise<AffiliateDetailsResponseDataType> {
  const { data } = await api.get(`/affiliates/details/${uuid}`);
  return data;
}

export async function fetchAffiliateInviteDetails(uuid: string): Promise<AffiliateDetailsResponseDataType> {
  const { data } = await api.get(`/affiliates/invite/${uuid}`);
  return data;
}

export async function fetchAffiliateProduct(affiliateUuid: string): Promise<AffiliateProductResponseDataType> {
  const { data } = await api.get(`/affiliates/${affiliateUuid}/statistics`);
  return data;
}
export interface AffiliateOfferDetailsResponseDataType {
  offer: Offer;
  plans: Plan[];
  orderBumpsCount: number;
  orderBumps: AffiliateOfferOderBump[];
}

export interface AffiliateOfferOderBump {
  name: string;
  price: number;
  photo: string;
}

export interface Offer {
  name: string;
  billingType: OfferConstants.BillingType;
  commission: number;
  checkoutUrl: string;
}

export interface Plan {
  name: string;
  price: number;
  commission: number;
  chargeFrequency: OfferConstants.ChargeFrequency;
  promotionalPrice?: number;
  firstChargePrice?: number;
  firstChargeCommission?: number;
  isFree: boolean;
}

export async function fetchAffiliateOfferDetails(uuid: string): Promise<AffiliateOfferDetailsResponseDataType> {
  const { data } = await api.get(`/affiliates/offer-details/${uuid}`);
  return data;
}

export interface AffiliateAndUserDetailsResponseDataType {
  status: AffiliateConstants.Status;
  canceledBy: AffiliateConstants.CanceledBy;
  salesCount: number;
  salesIncome: number;
  user: {
    name: string;
    photo: string;
    email: string;
  };
}

export async function fetchAffiliateAndUserDetails(
  affiliateUuid: string
): Promise<AffiliateAndUserDetailsResponseDataType> {
  const { data } = await api.get(`/affiliates/${affiliateUuid}/producer-details`);
  return data;
}

export const createAffiliation = (productUuid: string): AxiosPromise<{ uuid: string }> => {
  return api.post(`/affiliates`, { productUuid });
};
